import { queryClient } from "./queryClient";

const HEALTH_CHECK_URL = process.env.REACT_APP_API_URL + '/feature-flag';

function normalizeUrl(url) {
    let normalizedUrl = url;

    if (!url.startsWith('/')) {
        normalizedUrl = '/' + url;
    }

    if (url.endsWith('/')) {
        normalizedUrl = normalizedUrl.slice(0, -1);
    }

    return normalizedUrl;
}

function matchPath(pattern, actual) {
    const cleanUrl = actual.split('?')[0];

    const normalizedUrl = normalizeUrl(cleanUrl);

    const regexPattern =
        '^' +
        pattern
            .split('*')
            .map(part => part.replace(/[-/\\^$+?.()|[\]{}]/g, '\\$&'))
            .join('[^/]+') +
        '$';

    const regex = new RegExp(regexPattern);

    return regex.test(normalizedUrl);
}

export const fetchHealthStatus = async token => {
    const response = await fetch(HEALTH_CHECK_URL, {
        method: 'GET',
        headers: {
            Authorization: token,
            'Content-Type': 'application/json',
        },
    });

    return await response.json();
};

const checkEndpointIsActive = (listh, path) => {
    for (const item of listh) {
        if (matchPath(item.path, path)) {
            return item.active;
        }
    }

    return true;
};

export async function checkHealth(endpoint) {
    try {
        const { data } = await queryClient.fetchQuery(
            'healthStatus',
            fetchHealthStatus,
            {
                staleTime: 1 * 60 * 1000, // 5 minutes
                cacheTime: 1 * 60 * 1000, // 10 minutes
            }
        );

        return checkEndpointIsActive(data, endpoint);
    } catch (error) {
        return false;
    }
}
